export const MULTIPART_MIN_SIZE = 10 * 1024 * 1024;

export type { UploadTarget, UploadBlob } from "./UploadTarget";
